﻿declare const UIkit: any;

declare global
{
    interface StringConstructor 
    {
        format(formatString: string, ...args: unknown[]): string;
    }

    interface String
    {
        ensureSuffix(suffix: string): string;
        ensureNoSuffix(suffix: string): string;
        ensurePrefix(suffix: string): string;
        ensureNoPrefix(suffix: string): string;
        HTMLAttributeEncode(): string;
        replaceAll(search: string | RegExp, replacement: any): string;
    }

    function getParameterByName(name: string): string;
}

String.prototype.ensureSuffix = function (suffix: string): string
{
    let input = this;
    if (input)
    {
        if (!input.endsWith(suffix))
            input += suffix;
    }
    return input;
};

String.prototype.ensureNoSuffix = function (suffix: string): string
{
    let input = this;
    if (input)
    {
        if (input.endsWith(suffix))
            input = input.substring(0, input.length - suffix.length);
    }
    return input;
};

String.prototype.ensurePrefix = function (suffix: string): string
{
    let input = this;
    if (input)
    {
        if (!input.startsWith(suffix))
            input = suffix + input;
    }
    return input;
};

String.prototype.ensureNoPrefix = function (suffix: string): string
{
    let input = this;
    if (input)
    {
        if (input.startsWith(suffix))
            input = input.substring(suffix.length);
    }
    return input;
};

String.prototype.HTMLAttributeEncode = function (this: string): string 
{
    let output = "";

    // Remove any present escaping by creating a text element first
    const element = new Option(this);
    const text = element.innerHTML;
    const splitText = text.split("");

    // Replace Quotes
    for (let i = 0; i < splitText.length; i++) 
    {
        output += splitText[i]
            .replace("\"", "\\\"")
            .replace("'", "\\'");
    }

    return output;
};

(window as any).getParameterByName = function getParameterByName(name: string): string
{
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
    const results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
};

// Create a method to be able to use string formatting.
if (!String.format)
{
    String.format = function (formatString: string, ...args: unknown[]): string
    {
        return formatString.replace(/{(\d+)}/g, (match, number) => 
        {
            const index = parseInt(number, 10);
            return typeof args[index] !== "undefined" ? String(args[index]) : match;
        });
    };
}

if (!String.prototype.replaceAll)
{
    String.prototype.replaceAll = function (search, replacement)
    {
        const target = this.tostring();
        try
        {
            if (search instanceof RegExp)
            {
                return target.replace(new RegExp(search, "g"), replacement);
            }

            return target.split(search).join(replacement);
        }
        catch (err)
        {
            console.error(err);
            return target;
        }
    };
}

export { };

$(".js-header-orderprocess .js-back-button").on("click", function (event)
{
    event.preventDefault();

    window.history.back();
});